module.exports = __webpack_public_path__ + "header/icon-person-985bc2c70ee2ee19bdf8b4b7863004d0.svg";